// extracted by mini-css-extract-plugin
export default {"cover_section":"perfil-cover_cover_section__iJU8t","coverImg":"perfil-cover_coverImg__paAQ6"};